import { FlowSpecDto, SecurityTipSubject } from "@ampsec/platform-client";

export type TrainingSubject = {
    subject: SecurityTipSubject;
    name: string;
    description: string;
    enabled: boolean;
    flowSpecs: FlowSpecDto[];
    thumbnailUrl?: string;
    previewUrl?: string;
}

/**
 *
 * @param t - The translation function (typically `useI18n().t`) used to retrieve localized strings
 * @param flowSpecs - An array of FlowSpecDto objects to be mapped to TrainingFocus objects. If empty, an empty array is returned.
 * @returns An array of `TrainingFocus` objects containing the training focus data and the associated flow specs.
 */
export const getTrainingSubjects = (
  t: (key: string, defaultValue?: string | undefined) => string,
  activeSecurityTipSubjects: string[] = [],
  flowSpecs?: FlowSpecDto[],
) => {
  return [
    // MSB: Temporarily disabled until we start receiving safe AI signals
    // {
    //   subject: SecurityTipSubject.SAFE_AI_USAGE,
    //   name: t('SECURITY_TIP_FOCUS_TITLE_AI_USE'),
    //   description: t('SECURITY_TIP_FOCUS_DESCRIPTION_AI_USE'),
    //   enabled: activeSecurityTipSubjects.includes(SecurityTipSubject.SAFE_AI_USAGE),
    //   flowSpecs: flowSpecs?.filter((flowSpec) => flowSpec.securityTip?.isConfigured === true && flowSpec.securityTip?.subject === SecurityTipSubject.SAFE_AI_USAGE) ?? []
    // },
    {
      subject: SecurityTipSubject.PASSWORDS_AND_CREDENTIALS,
      name: t('SECURITY_TIP_FOCUS_TITLE_PASSWORDS'),
      description: t('SECURITY_TIP_FOCUS_DESCRIPTION_PASSWORDS'),
      enabled: activeSecurityTipSubjects.includes(SecurityTipSubject.PASSWORDS_AND_CREDENTIALS),
      flowSpecs: flowSpecs?.filter((flowSpec) => flowSpec.securityTip?.isConfigured === true && flowSpec.securityTip?.subject === SecurityTipSubject.PASSWORDS_AND_CREDENTIALS) ?? [],
      thumbnailUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_PASSWORDS'),
      previewUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_PASSWORDS'),
    },
    {
      subject: SecurityTipSubject.DATA_AND_PRIVACY,
      name: t('SECURITY_TIP_FOCUS_TITLE_DATAHANDLING'),
      description: t('SECURITY_TIP_FOCUS_DESCRIPTION_DATAHANDLING'),
      enabled: activeSecurityTipSubjects.includes(SecurityTipSubject.DATA_AND_PRIVACY),
      flowSpecs: flowSpecs?.filter((flowSpec) => flowSpec.securityTip?.isConfigured === true && flowSpec.securityTip?.subject === SecurityTipSubject.DATA_AND_PRIVACY) ?? [],
      thumbnailUrl: t('SECURITY_TIP_THUMBNAIL_LINK_DATAHANDLING'),
      previewUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_PASSWORDS'),
    },
    {
      subject: SecurityTipSubject.DEVICE_SECURITY,
      name: t('SECURITY_TIP_FOCUS_TITLE_DEVICE_SECURITY'),
      description: t('SECURITY_TIP_FOCUS_DESCRIPTION_DEVICE_SECURITY'),
      enabled: activeSecurityTipSubjects.includes(SecurityTipSubject.DEVICE_SECURITY),
      flowSpecs: flowSpecs?.filter((flowSpec) => flowSpec.securityTip?.isConfigured === true && flowSpec.securityTip?.subject === SecurityTipSubject.DEVICE_SECURITY) ?? [],
      thumbnailUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_DEVICE_SECURITY'),
      previewUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_DEVICE_SECURITY'),
    },
    {
      subject: SecurityTipSubject.PHISHING,
      name: t('SECURITY_TIP_FOCUS_TITLE_PHISHING'),
      description: t('SECURITY_TIP_FOCUS_DESCRIPTION_PHISHING'),
      enabled: activeSecurityTipSubjects.includes(SecurityTipSubject.PHISHING),
      flowSpecs: flowSpecs?.filter((flowSpec) => flowSpec.securityTip?.isConfigured === true && flowSpec.securityTip?.subject === SecurityTipSubject.PHISHING) ?? [],
      thumbnailUrl: t('SECURITY_TIP_THUMBNAIL_LINK_PHISHING'),
      previewUrl: t('SECURITY_TIP_PREVIEW_IMAGE_LINK_PASSWORDS'),
    }
  ];
};